declare var urlConfig;

export const environment = {
  production: false,
  baseUrl: urlConfig.baseUrl,
  redirectUrl: urlConfig.redirectUrl,
  liveUrl: urlConfig.liveUrl,
  loginURL: urlConfig.loginURL,
  accUrl: urlConfig.accUrl,
  s3AwsUrl: urlConfig.s3AwsUrlPayroll,
  s3AwsUrlHRIS: urlConfig.s3AwsUrlHRIS,
};

/* JOMAKHATA */
// export const environment = {
//   production: false,
//   baseUrl: 'https://payroll-api.jomakhata.com/',
//   redirectUrl: 'https://payroll.jomakhata.com',
//   liveUrl: 'https://www.jomakhata.com/',
//   loginURL: 'https://login.jomakhata.com/',
//   accUrl: 'https://accounting.jomakhata.com/',
//   s3AwsUrl: 'https://erp-jomakhata-file-uploads.s3.amazonaws.com/payroll-api',
//   s3AwsUrlHRIS: 'https://erp-jomakhata-file-uploads.s3.amazonaws.com/hris-api',
// };

/* MAX-PRODUCTION */
// export const environment = {
//   production: false,
//   baseUrl: 'https://payroll-api.maxrailwaytrack.com/',
//   redirectUrl: 'https://payroll.maxrailwaytrack.com/',
//   liveUrl: 'https://www.maxrailwaytrack.com/',
//   loginURL: 'https://login.maxrailwaytrack.com/',
//   accUrl: 'https://accounting.maxrailwaytrack.com/',
// };

/* SKL-ERP */
// export const environment = {
//   production: false,
//   baseUrl: 'https://payroll-api.sklerp.com/',
//   redirectUrl: 'https://payroll.sklerp.com',
//   liveUrl: 'https://www.sklerp.com/',
//   loginURL: 'https://login.sklerp.com/',
//   accUrl: 'https://accounting.sklerp.com/',
// };

/* SHARMIN-TEXTILE */
// export const environment = {
// 	production: false,
// 	baseUrl: 'https://payroll-api.sharminerp.com/',
// 	redirectUrl: 'https://payroll.sharminerp.com/',
// 	liveUrl: 'https://requisition.sharminerp.com/',
// 	loginURL: 'https://www.sharminerp.com/',
//  accUrl: 'https://accounting.sharminerp.com/',
// };

/* CCECC-MAX */
// export const environment = {
//   production: false,
//   baseUrl: 'https://payroll-api.cceccmax.com/',
//   redirectUrl: 'https://payroll.cceccmax.com/',
//   liveUrl: 'https://www.cceccmax.com/',
//   loginURL: 'https://login.cceccmax.com/',
//   accUrl: 'https://accounting.cceccmax.com/',
// };



// WEBPACK FOOTER //
// ./src/environments/environment.ts